module.exports = __webpack_public_path__ + "img/xiaoyi.47b1626f.jpg";